// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__dO0Jo","left":"StickyBox_left__1v5KX","right":"StickyBox_right__1p6kV"};